(() => {
  'use strict';

  const LOW_RES_RE = /webshop\.schmitter-hydraulik\.de\/media\/image\/200x200\//i;
  const TEST_SIZES = ['1200x1200', '1000x1000', '800x800', '600x600'];
  const stats = {
    found: 0,
    upgradedSameImage: 0,
    keptOriginal: 0,
    existingMedium: 0,
    existingLow: 0,
    errors: 0
  };

  const uniq = arr => [...new Set(arr.filter(Boolean))];

  function isLowResSchmitter(src) {
    return LOW_RES_RE.test(String(src || ''));
  }

  function candidateUrls(src) {
    const value = String(src || '');
    const urls = [
      value.replace('/media/image/200x200/', '/media/image/')
    ];

    TEST_SIZES.forEach(size => {
      urls.push(value.replace('/media/image/200x200/', '/media/image/' + size + '/'));
    });

    return uniq(urls);
  }

  function probe(url, minWidth = 500, minHeight = 320, timeoutMs = 4500) {
    return new Promise(resolve => {
      const tester = new Image();
      let settled = false;

      const done = ok => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        tester.onload = null;
        tester.onerror = null;
        resolve(ok ? { url, width: tester.naturalWidth || 0, height: tester.naturalHeight || 0 } : null);
      };

      const timer = setTimeout(() => done(false), timeoutMs);
      tester.onload = () => done(
        (tester.naturalWidth || 0) >= minWidth &&
        (tester.naturalHeight || 0) >= minHeight
      );
      tester.onerror = () => done(false);
      tester.src = url;
    });
  }

  async function findSameImageHD(src) {
    const checks = await Promise.all(candidateUrls(src).map(url => probe(url)));
    const firstValid = checks.find(Boolean);
    return firstValid ? firstValid.url : null;
  }

  function markExistingQuality(img) {
    if (!img || img.dataset.hfQualityChecked === 'true') return;

    const apply = () => {
      img.dataset.hfQualityChecked = 'true';

      const src = img.currentSrc || img.src || '';
      const w = img.naturalWidth || 0;
      const h = img.naturalHeight || 0;
      if (!src || !w || !h) return;

      img.classList.add('hf-image-quality');

      if (isLowResSchmitter(src)) {
        img.classList.add('hf-image-quality--low');
        return;
      }

      if (w < 400 || h < 250) {
        img.classList.add('hf-image-quality--low');
        stats.existingLow++;
      } else if (w < 1000 || h < 550) {
        img.classList.add('hf-image-quality--medium');
        stats.existingMedium++;
      }
    };

    if (img.complete) apply();
    else img.addEventListener('load', apply, { once: true });
  }

  async function upgradeSameImageOnly(img) {
    if (!img) return;

    const src = img.currentSrc || img.src || '';

    if (!isLowResSchmitter(src)) {
      markExistingQuality(img);
      return;
    }

    stats.found++;

    try {
      const hd = await findSameImageHD(src);

      if (hd) {
        img.src = hd;
        img.removeAttribute('srcset');
        img.dataset.hfHdSource = 'same-schmitter-image';
        img.classList.add('hf-image-quality');
        stats.upgradedSameImage++;
      } else {
        img.dataset.hfHdSource = 'original-kept';
        img.classList.add('hf-image-quality', 'hf-image-quality--low');
        stats.keptOriginal++;
      }
    } catch (error) {
      img.dataset.hfHdSource = 'original-kept-error';
      img.classList.add('hf-image-quality', 'hf-image-quality--low');
      stats.errors++;
      console.warn('[Hydroflex Bildschärfe] Originalbild beibehalten:', error);
    }
  }

  async function run() {
    const images = [
      ...document.querySelectorAll('.hf-category__img'),
      ...document.querySelectorAll('.hf-category__areahead-mark img')
    ];

    await Promise.all(images.map(upgradeSameImageOnly));

    window.__HF_IMAGE_HD_AUDIT__ = {...stats};
    document.documentElement.dataset.hfImageHdDone = 'true';
    console.info('[Hydroflex Bildschärfe] Prüfung abgeschlossen', window.__HF_IMAGE_HD_AUDIT__);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();